<template>
    <div class="map">
        <ResultsMap :locations="resultsWithLocation" />
    </div>
</template>

<script>
import axios from 'axios'
import ObjectMixins from '@/mixins/ObjectMixins';
import SiteMixins from '@/mixins/SiteMixins';
import CurrencyMixins from '@/mixins/CurrencyMixins';
import ResultsMap from '@/components/elements/ResultsMap';

export default {
    name: 'Map',
    head: {
        title() {
            return {
                inner: 'Map',
            }
        },
    },
    mixins: [
        ObjectMixins,
        SiteMixins,
        CurrencyMixins,
    ],
    components: {
        ResultsMap,
    },
    data() {
        return {
            accessToken: process.env.VUE_APP_MAPBOX_ACCESS_TOKEN,
            mapStyle: process.env.VUE_APP_MAPBOX_MAP_STYLE,
            results: [],
        }
    },
    computed: {
        resultsWithLocation() {
            return this.results && this.results.data && this.results.data.filter(result => result.location.coords != null) || []
        }
    },
    created() {
        let loader = this.$loading.show();
        axios({
            url: process.env.VUE_APP_API_BASE_URL + `/sites?limit=1000`,
            method: 'GET',
        }).then(response => {
            this.results = response.data
            loader.hide()
        }).catch(error => {
            console.log({ error: error })
            loader.hide()
        })
    },
};
</script>

<style lang="scss" scoped>
.map {
    #map {
        margin-top: -24px;
        margin-bottom: -20px;
        height: 80vh;
    }
}
</style>